import api, { PriceListListElement } from "@/service/api";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
    name: "PriceLists"
})
export default class PriceListsModule extends VuexModule {
    private list: PriceListListElement[] = [];

    @Mutation
    setList(list: PriceListListElement[]) {
        this.list = list;
    }

    @Action({
        rawError: true
    })
    async fetchPriceLists() {
        this.setList(await api.getPriceLists());
    }

    @Action({
        rawError: true,
    })
    async deletePriceList(id: string) {
        await api.deletePriceList(id);
        await this.fetchPriceLists();
    }

    @Action({
        rawError: true,
    })
    async clonePriceList(id: string) {
        await api.clonePriceList(id);
        await this.fetchPriceLists();
    }

    get priceListList() {
        return this.list;
    }

    @Action({
        rawError: true
    })
    async selectPriceList({ sessionId, priceListId }: { sessionId: string; priceListId: string|null; }) {
        console.log({priceListId});
        await api.selectPriceList(sessionId, priceListId);
    }
}
